import React from 'react'
import { Typography } from '@mui/material'
import { SxProps, Theme } from '@mui/material/styles'

interface TextProps {
  text?: unknown
  isBold?: boolean
  sx?: SxProps<Theme>
  theme?:
    | 'blue'
    | 'dark'
    | 'light'
    | 'muted'
    | 'black'
    | 'warning'
    | 'red'
    | 'darkPrimary'
    | 'highlight'
    | 'info'
  variant?:
    | 'body3'
    | 'body2'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'subtitle1'
    | 'subtitle2'
    | 'body1'
    | 'caption'
    | 'button'
    | 'overline'
    | 'inherit'
  children?: React.ReactNode
  isUnderlined?: boolean
  fontSize?: string
  fontWeight?: number
  // all other props
  [x: string]: unknown
}
export default function NormalText({
  text,
  isBold = false,
  isUnderlined,
  sx,
  theme = 'dark',
  variant = 'body1',
  children,
  ...props
}: TextProps) {
  return (
    <Typography
      variant={variant === 'body3' ? 'body2' : variant}
      fontSize={
        variant === 'body1'
          ? '14px'
          : variant === 'body2'
          ? '12px'
          : variant === 'body3'
          ? '10px'
          : props.fontSize
      }
      fontWeight={isBold ? 700 : props.fontWeight ? props.fontWeight : 400}
      sx={[
        {
          color:
            theme === 'blue'
              ? '#1400B8'
              : theme === 'dark'
              ? '#333333'
              : theme === 'light'
              ? 'white'
              : theme === 'muted'
              ? '#7B8794'
              : theme === 'warning'
              ? '#CB1818'
              : theme === 'darkPrimary'
              ? '#000869'
              : theme === 'highlight'
              ? '#C51398'
              : theme === 'info'
              ? '#818D9C'
              : 'black',
          fontFamily: 'SF Pro Display, sans-serif',
          fontStyle: 'normal',
          textDecoration: isUnderlined ? 'underline' : 'none'
        },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
      {...props}
    >
      <>
        {text}
        {children}
      </>
    </Typography>
  )
}
